/** Exporta linhas tipadas como CSV (UTF-8 BOM para Excel). */
export function downloadCsv(
  filename: string,
  headers: readonly string[],
  rows: readonly (readonly string[])[],
): void {
  const escape = (cell: string) => `"${cell.replaceAll('"', '""')}"`;
  const lines = [
    headers.map(escape).join(","),
    ...rows.map((row) => row.map(escape).join(",")),
  ];
  downloadCsvText(filename, `\uFEFF${lines.join("\n")}`);
}

/** Dispara download a partir do texto CSV (resposta da API auditada). */
export function downloadCsvText(filename: string, csv: string): void {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
